import React from 'react';

import { equityProductsQuery } from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getEquityFilters, tableHead } from './constants';
import ProductItem from './item';
import { PaidCustody } from './PaidCustody';

export const EquityTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={equityProductsQuery}
      productsFiltersGetter={getEquityFilters}
      tableHeadItems={tableHead}
      tabletColumns={5}
      SecondaryInfo={PaidCustody}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'assetNameNormalized', label: 'Ativo' },
        { key: 'availableQuantityNormalized', label: 'Qtd. disponível' },
        { key: 'unavailableQuantityNormalized', label: 'Qtd. indisponível' },
        { key: 'currentPriceNormalized', label: 'Preço atual' },
        { key: 'averagePriceNormalized', label: 'Preço médio' },
        { key: 'valueNormalized', label: 'Valor' },
      ]}
    />
  );
};
